module.exports = __webpack_public_path__ + "static/media/Rossmann_Bold.edc1f1ee.woff2";